import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const GuideIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M12 1.25C6.0723 1.25 1.25 6.0723 1.25 12C1.25 17.9277 6.0723 22.75 12 22.75C17.9277 22.75 22.75 17.9277 22.75 12C22.75 6.0723 17.9277 1.25 12 1.25ZM12 21.25C6.8994 21.25 2.75 17.1006 2.75 12C2.75 6.8994 6.8994 2.75 12 2.75C17.1006 2.75 21.25 6.8994 21.25 12C21.25 17.1006 17.1006 21.25 12 21.25Z"
        fill={color}
      />
      <path
        d="M12.375 16H11.625C11.2798 16 11 16.2798 11 16.625V17.375C11 17.7202 11.2798 18 11.625 18H12.375C12.7202 18 13 17.7202 13 17.375V16.625C13 16.2798 12.7202 16 12.375 16Z"
        fill={color}
      />
      <path
        d="M11.9995 6.0001C9.72879 6.0003 8.24999 7.2982 8.02899 9.428C7.99799 9.73 8.22199 10 8.52599 10H9.52899C9.77199 10 9.99399 9.828 10.021 9.586C10.177 8.191 11.146 8 11.999 8C13.659 8 13.999 8.681 13.999 9.704C13.999 10.465 13.211 10.78 12.872 10.88C11.769 11.206 10.999 12.234 10.999 13.38V14C10.999 14.276 11.223 14.5 11.499 14.5H12.499C12.775 14.5 12.999 14.276 12.999 14V13.38C12.999 13.101 13.1939 12.871 13.461 12.791C15.027 12.319 15.999 11.138 15.999 9.704C15.999 7.3502 14.5412 6.0003 11.9995 6.0001Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

GuideIcon.displayName = 'GuideIcon';
